import { render, staticRenderFns } from "./DepartmentUserForm.vue?vue&type=template&id=74ecf5de&scoped=true"
import script from "./DepartmentUserForm.vue?vue&type=script&lang=js"
export * from "./DepartmentUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ecf5de",
  null
  
)

export default component.exports